var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle4, _circle5, _circle6, _rect, _rect2, _rect3, _path13, _path14, _path15, _rect4, _rect5, _path16, _path17, _path18;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 823.23953,
    height: 735.54047,
    viewBox: "0 0 823.23953 735.54047",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M958.69312,482.97282,369.50873,735.0358a16.51867,16.51867,0,0,1-21.66-8.68L192.42164,363.05291a12.10184,12.10184,0,0,1,6.3588-15.86858l597.105-255.45154a12.31112,12.31112,0,0,1,16.14288,6.46929L967.37315,461.31279A16.51867,16.51867,0,0,1,958.69312,482.97282Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M931.44937,471.96945,382.3449,706.88557c-8.04931,3.44363-17.22127.11287-20.44591-7.42456L226.55112,383.09225c-2.39149-5.59.51531-12.214,6.48-14.76586L789.51739,130.25223c6.06362-2.59412,12.97442-.08152,15.40529,5.60051L940.19911,452.0545C943.42375,459.59193,939.49857,468.52586,931.44937,471.96945Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M812.54362,99.99072,193.01749,365.03441l-3.30415-7.72328a16.57377,16.57377,0,0,1,8.71566-21.72945L787.50463,83.56523a16.57368,16.57368,0,0,1,21.73484,8.7022Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#4f31c5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.40974,
    cy: 259.52048,
    r: 4.28342,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.35802,
    cy: 253.12536,
    r: 4.28342,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.3063,
    cy: 246.73023,
    r: 4.28342,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.26816,446.007l-73.22891,31.32856a16.519,16.519,0,0,1-21.66-8.68l-40.42342-94.4877a16.519,16.519,0,0,1,8.68-21.66l73.2289-31.32855a16.519,16.519,0,0,1,21.66,8.68L500.9482,424.347A16.519,16.519,0,0,1,492.26816,446.007Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M616.17675,392.99683l-73.2289,31.32856a16.519,16.519,0,0,1-21.66-8.68l-40.42343-94.48769a16.519,16.519,0,0,1,8.68-21.66l73.22891-31.32855a16.519,16.519,0,0,1,21.66,8.68l40.42342,94.48769A16.519,16.519,0,0,1,616.17675,392.99683Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M740.08535,339.98665l-73.22913,31.32866a16.519,16.519,0,0,1-21.66-8.68l-40.42343-94.4877a16.519,16.519,0,0,1,8.68-21.66l73.22913-31.32865a16.519,16.519,0,0,1,21.66,8.68l40.42343,94.48769A16.519,16.519,0,0,1,740.08535,339.98665Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M554.80812,592.191l-73.22891,31.32856a16.519,16.519,0,0,1-21.66-8.68l-40.42342-94.48769a16.519,16.519,0,0,1,8.68-21.66l73.2289-31.32855a16.519,16.519,0,0,1,21.66,8.68L563.48816,570.531A16.519,16.519,0,0,1,554.80812,592.191Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M678.71671,539.1808l-73.2289,31.32856a16.519,16.519,0,0,1-21.66-8.68l-40.42343-94.48769a16.519,16.519,0,0,1,8.68-21.66L625.3133,414.353a16.519,16.519,0,0,1,21.66,8.68l40.42342,94.48769A16.519,16.519,0,0,1,678.71671,539.1808Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M802.62531,486.17063l-73.22913,31.32865a16.519,16.519,0,0,1-21.66-8.68l-40.42343-94.4877a16.519,16.519,0,0,1,8.68-21.66l73.22913-31.32865a16.519,16.519,0,0,1,21.66,8.68l40.42343,94.48769A16.519,16.519,0,0,1,802.62531,486.17063Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M995.11977,817.77023H354.28126a16.51867,16.51867,0,0,1-16.5-16.5V406.11643a12.10185,12.10185,0,0,1,12.0879-12.08838H999.32265a12.31112,12.31112,0,0,1,12.29712,12.29736V801.27023A16.51867,16.51867,0,0,1,995.11977,817.77023Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M974.4,796.93791H377.15521c-8.755,0-15.87757-6.66992-15.87757-14.86816v-344.105c0-6.08008,5.278-11.02686,11.76563-11.02686H978.317c6.59522,0,11.96069,5.02832,11.96069,11.2085V782.06975C990.27764,790.268,983.15484,796.93791,974.4,796.93791Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.39,408.17258H337.5497v-8.40039a16.57377,16.57377,0,0,1,16.56006-16.54981H994.83A16.57369,16.57369,0,0,1,1011.39,399.77219Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#4f31c5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.26482,
    cy: 313.49262,
    r: 4.28342,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.52363,
    cy: 313.49262,
    r: 4.28342,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.78243,
    cy: 313.49262,
    r: 4.28342,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 450.20268,
    y: 441.30559,
    width: 324,
    height: 41.02752,
    rx: 20.51374,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 450.20268,
    y: 509.19439,
    width: 324,
    height: 41.02752,
    rx: 20.51374,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 450.20268,
    y: 577.08318,
    width: 324,
    height: 41.02752,
    rx: 20.51374,
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M611.97238,611.93791a110,110,0,1,1-110-110A110.03475,110.03475,0,0,1,611.97238,611.93791Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M552.81243,630.76c-1.20147,70.35088-105.847,70.33985-107.03823-.00226C446.97559,560.40911,551.62115,560.42014,552.81243,630.76Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#4f31c5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M497.16883,652.596l-.05566-2c13.78447,1.84042,16.75312-15.24334,2.85156-8.85644l3.17334-23.19043,1.98145.27148-2.69922,19.72657C517.05748,636.36835,511.64336,654.59479,497.16883,652.596Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 326.5386,
    y: 538.29199,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 292.5386,
    y: 538.29199,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M516.6423,705.58794c2.1001-14.17-14.48975-11.37-23.27-11.51a9.518,9.518,0,0,0-9.27979,11.5,52.0381,52.0381,0,0,0-18.49023,10.2,110.47619,110.47619,0,0,0,70.43018.78A51.77082,51.77082,0,0,0,516.6423,705.58794Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M474.13161,605.44681c9.9184-5.73223,21.94644-1.3346,32.19177,1.06973,19.43829,5.9755,46.6969-1.50709,49.06067-24.66246,2.45987-21.53491-26.99912-33.5371-36.41493-12.10366l2.74162-.35832c-30.53675-45.38215-83.65461-43.661-83.30532,18.73141-.11322,1.92749,2.88716,1.921,2.99939-.00115-1.12422-36.76687,23.20862-61.89966,57.60511-38.27162,7.87161,5.74339,14.24117,13.35026,20.11041,21.05552,3.58221,4.01447,4.36067-13.27437,21.50583-8.746,18.86876,7.31,12.712,34.32848-4.15335,40.25979-20.83849,10.64622-43.40723-9.9954-63.8555.435a1.50174,1.50174,0,0,0,1.5143,2.59173Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.97238,724.93791a112.90489,112.90489,0,1,1,34.98755-5.52685A112.72659,112.72659,0,0,1,501.97238,724.93791Zm0-220a107.01519,107.01519,0,1,0,107,107A107.12118,107.12118,0,0,0,501.97238,504.93791Z",
    transform: "translate(-188.38023 -82.22977)",
    fill: "#3f3d56"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.600d825c996f1f6c4a88118eb47354ff.svg";
export { ForwardRef as ReactComponent };